export default {
    buscando: false,
    items: [

        {
            icone: '',
            titulo: 'App',
            url: '',
            submenu: [{
                    icone: '',
                    titulo: 'Dashboard',
                    nome: 'dashboard',
                    url: '/app/dashboard',
                },
                {
                    icone: '',
                    titulo: 'Usuários',
                    url: '/app/usuarios',
                } ,
                {
                    icone: '',
                    titulo: 'Usuários Perfis',
                    url: '/app/usuarios-perfis',
                },
                {
                    icone: '',
                    titulo: 'Perfis Menus',
                    url: '/perfis-menus',
                },
                {
                    icone: '',
                    titulo: 'Perfis Rotas',
                    url: '/perfis-rotas',
                },
                {
                    icone: '',
                    titulo: 'Menus',
                    url: '/app/menus',
                },
                {
                    icone: '',
                    titulo: 'Módulos',
                    url: '/app/modulos',
                },
                {
                    icone: '',
                    titulo: 'Submódulos',
                    url: '/app/submodulos',
                },
                {
                    icone: '',
                    titulo: 'Rotas',
                    url: '/app/rotas',
                }
            ]
        },
       
        {
            icone: '',
            titulo: 'Esteira Embratel',
            url: '',
            submenu: [                
                {
                    icone: '',
                    titulo: 'Nível de Hierarquia',
                    url: '/sgp/tipos-hierarquias',
                },
                {
                    icone: '',
                    titulo: 'Tipo de Status',
                    url: '/sgp/tipos-status',
                },
                {
                    icone: '',
                    titulo: 'Processos',
                    url: '/processos',
                },
                {
                    icone: '',
                    titulo: 'Tipo de Tarefas',
                    url: '/tipos-tarefas',
                },
                {
                    icone: '',
                    titulo: 'Status',
                    url: '/status',
                },
                {
                    icone: '',
                    titulo: 'Tarefas',
                    url: '/tarefas',
                },
                {
                    icone: '',
                    titulo: 'Tarefas Mobilidades',
                    url: '/tarefas-mobilidades',
                },
                {
                    icone: '',
                    titulo: 'Tarefas Status',
                    url: '/tarefas-status',
                },
            ]
        },
        {
            icone:'',
            titulo: 'Formulário Dinâmico',
            url: '#',
            submenu: [
                {
                    icone: '',
                    titulo: 'Formulario',
                    url: '/forms/formulario',
                }
            ]
        }
    ],
    menuSelecionado: ''
}